import { render, staticRenderFns } from "./SyncInventoryModal.vue?vue&type=template&id=99470e4a&scoped=true"
import script from "./SyncInventoryModal.vue?vue&type=script&lang=js"
export * from "./SyncInventoryModal.vue?vue&type=script&lang=js"
import style0 from "./SyncInventoryModal.vue?vue&type=style&index=0&id=99470e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99470e4a",
  null
  
)

export default component.exports